export interface Row {
	id: string;
	nurseId: string;
	nurseName: string;
	functionId: string;
	functionName: string;
	hospitalId: string;
	hospitalName: string;
	areaId: string;
	areaName: string;
	date: string;
}

export function createRow(
	id: string,
	nurseId: string,
	nurseName: string,
	functionId: string,
	functionName: string,
	hospitalId: string,
	hospitalName: string,
	areaId: string,
	areaName: string,
	date: string,
): Row {
	return {
		id,
		nurseId,
		nurseName,
		functionId,
		functionName,
		hospitalId,
		hospitalName,
		areaId,
		areaName,
		date,
	};
}

export interface HeadCell {
	id: keyof Row;
	label: string;
	width: string;
}

export const headCells: readonly HeadCell[] = [
	{
		id: "nurseName",
		label: "Profesional",
		width: "23",
	},
	{
		id: "hospitalName",
		label: "Hospital",
		width: "15",
	},
	{
		id: "areaName",
		label: "Sector",
		width: "18",
	},
	{
		id: "functionName",
		label: "Función",
		width: "20",
	},
	{
		id: "date",
		label: "Fecha",
		width: "15",
	},
];

export const headCellsWithoutHospital: readonly HeadCell[] = [
	{
		id: "nurseName",
		label: "Profesional",
		width: "23",
	},

	{
		id: "areaName",
		label: "Sector",
		width: "18",
	},
	{
		id: "functionName",
		label: "Función",
		width: "20",
	},
	{
		id: "date",
		label: "Fecha",
		width: "15",
	},
];
